<template>
  <v-container>
    <landing-create :content="createPermissionContent"></landing-create>
    <list-component
      :service="service"
      :tableMetaData="tableMetaData"
    ></list-component>
    <v-dialog v-model="isView">
      <specimen-additional-info-view
        :specimenAdditionalInfo="specimenAdditionalInfo"
      ></specimen-additional-info-view>
    </v-dialog>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import ListComponent from '../../../components/ListComponent.vue';

import SpecimenAdditionalInfoView from './SpecimenAdditionalInfoView.vue';

import services from '../../../services';

const { biobankRegistry } = services;
const { specimenAdditionalInfoService } = biobankRegistry;

export default {
  name: 'SpecimenAdditionalInfoList',
  components: {
    LandingCreate,
    ListComponent,
    SpecimenAdditionalInfoView,
  },
  data() {
    const component = this;
    return {
      service: specimenAdditionalInfoService,
      specimenAdditionalInfo: null,
      isView: false,
      createPermissionContent: {
        pageTitle: 'Specimen Additional Info',
        commands: [
          {
            link: 'specimenAdditionalInfo.create',
            icon: 'mdi-plus-box',
            buttonName: 'Create',
          },
        ],
      },
      tableMetaData: {
        tableFilters: {
          selections: [],
          dates: [
            {
              text: 'Date created',
              column: 'dateCreated',
            },
          ],
        },
        tableHeaders: [
          {
            text: 'Name',
            value: 'name',
          },
          {
            text: 'Type',
            value: 'type',
          },
          {
            text: 'Date created',
            value: 'dateCreated',
          },
          {
            text: 'Actions',
            value: 'actions',
          },
        ],
        URLName: 'specimenAdditionalInfo',
        actionDisplay: {
          delete: {
            visible: true,
            icon: () => 'mdi-delete-empty',
          },
        },
        onClickArchive(item) {
          component.onArchive(item);
        },
      },
    };
  },
  methods: {
    async onArchive(item) {
      this.isLoading = true;
      try {
        await specimenAdditionalInfoService.archive({ specimenAdditionalInfo: item });
        this.$snackbar.show({
          text: 'Successfully deleted specimen additional info!',
          closeColor: 'white',
          color: 'green',
        });
      } catch (e) {
        const { message } = e.response.data;
        this.$snackbar.show({ color: 'red', text: message, closeColor: 'white' });
      }
      this.isLoading = false;
    },
  },
  created() {
    this.tableMetaData.onClickView = (specimenAdditionalInfo) => {
      this.specimenAdditionalInfo = specimenAdditionalInfo;
      this.isView = true;
    };
  },
};
</script>
